import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Underline } from "@/components/typography/Body14Underline";
import { DepartmentDto } from "@/types/dto/department-dto";
import { Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";

interface Props {
  data: DepartmentDto;
  index: number;
  startIndex: number;
  openModal: (department?: DepartmentDto) => void;
}

export const Row: React.FC<Props> = ({
  data,
  index,
  startIndex,
  openModal,
}) => {
  return (
    <Table.Row
      key={data.id}
      className="bg-white dark:border-gray-700 dark:bg-gray-800"
    >
      <Table.Cell
        onClick={() => {
          openModal(data);
        }}
      >
        <CustomCell>
          <Body14Underline>{data.name}</Body14Underline>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{`${data.numUsers || 0}명`}</Body14Regular>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
